import type {
	AgreementCondition,
	AgreementConditionForm,
} from "types/index";
import { AgreementConditionSchema } from "view/agreementconditions/schema";
import type { AgreementConditionInput } from "__generated__/graphql";
import { AgreementConditionOutput } from "view/agreementconditions/validation/agreementcondition.zod";

export const convertConditionToForm = (condition: AgreementCondition) => {
	const schemaForm = AgreementConditionSchema[condition.type]?.toForm?.(condition);

	const baseForm: Partial<AgreementConditionForm> = {
		id: condition.id,
		type: condition.type,
	};

	return schemaForm ? { ...baseForm, ...schemaForm } : { ...baseForm };
};

export const convertConditionFormToInput = (form: AgreementConditionOutput) => {
	const schemaInput = form.type ? AgreementConditionSchema[form.type]?.toInput?.(form) : undefined;

	const baseInput: Partial<AgreementConditionInput> = {
		id: form.id,
		type: form.type,
	};

	return schemaInput ? { ...baseInput, ...schemaInput } : { ...baseInput };
};
